export default "/images/vendor/lightgallery.js/dist/loading.gif?621cc8ad61b6eb26c7165eb447f3d8fd";